var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section brands-section"},[_c('div',{staticClass:"brands"},[_c('h3',{staticClass:"section__title"},[_vm._v("Destinations")]),_c('BrandsSwiper',{attrs:{"brands":_vm.brands}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }